function init() {
  // Remove "Uncategorized" from category lists (sidebar filter)
  document.querySelectorAll('.wd-dropdown-product-cat>option[value=uncategorized]').forEach(el => el.remove());
}

export default { init };